/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserSigniContractsCountResource } from './userSigniContractsCountResource';
import { UserSigniContractsCount200ResponseMeta } from './userSigniContractsCount200ResponseMeta';


export interface UserSigniContractsCount200Response { 
    data: UserSigniContractsCountResource;
    meta: UserSigniContractsCount200ResponseMeta;
}

